/* Lista de deseos simple */
(function () {
  const KEY = 'ferrys_wishlist_v1';
  const $$ = (s, r=document) => Array.from(r.querySelectorAll(s));

  function getList(){ try{ return JSON.parse(localStorage.getItem(KEY)) || []; }catch(e){ return []; } }
  function setList(list){
    const unique = [...new Set(list.filter(Boolean))];
    localStorage.setItem(KEY, JSON.stringify(unique));
    updateHeaderCount();
    updateButtonsState(document);
  }
  function inList(handle){ return getList().includes(handle); }
  function add(handle){ if (!handle) return; if (!inList(handle)) setList([...getList(), handle]); }
  function remove(handle){ setList(getList().filter(h => h !== handle)); }
  function toggle(handle){ inList(handle) ? remove(handle) : add(handle); }

  function updateHeaderCount(){
    const n = getList().length;
    $$('[data-wishlist-count]').forEach(el => { el.textContent = n; el.hidden = false; });
  }
  function updateButtonsState(root=document){
    $$('.wishlist-bookmark', root).forEach(btn=>{
      const handle = btn.getAttribute('data-product-handle');
      const active = inList(handle);
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  // ÚNICO listener: parar navegación y hacer toggle
  document.addEventListener('click', function(e){
    const btn = e.target && e.target.closest && e.target.closest('.wishlist-bookmark');
    if (!btn) return;

    e.preventDefault();      // no navegamos
    e.stopPropagation();     // no dejamos que suba al overlay

    const handle = btn.getAttribute('data-product-handle');
    if (!handle) return;

    toggle(handle);          // add/remove + refresca estados y contador
  }, false);

  // Rehidratar cuando se carga la página y cuando Shopify recarga secciones
  document.addEventListener('DOMContentLoaded', ()=>{ updateHeaderCount(); updateButtonsState(document); });
  document.addEventListener('shopify:section:load', (ev)=> updateButtonsState(ev.target));
  document.addEventListener('shopify:block:select', (ev)=> updateButtonsState(ev.target));

  // Exponer por consola
  window.FerrysWishlist = { get:getList, add, remove, toggle };
})();
